function findHierarchyNextItem({ mappedHierarchy, element, requiredArray }) {
  // console.log(element);
  // console.log(element.hierarchyKey);

  const hierachyItem = mappedHierarchy[element.hierarchyKey];
  // console.log(hierachyItem);

  const hierarchyCurrentItemIndex =
    hierachyItem !== undefined
      ? hierachyItem.hierarchyArray.findIndex((hItem) => {
          // console.log(hItem.nanoId);
          // console.log(element.nanoId);
          return hItem.nanoId === element.nanoId;
        })
      : -1;

  let hierarchyNextItem;
  // console.log(hierarchyCurrentItemIndex);
  if (hierarchyCurrentItemIndex !== -1) {
    const nextItem = hierachyItem.hierarchyArray[hierarchyCurrentItemIndex + 1];
    // console.log(nextItem);
    if (nextItem) {
      if (nextItem.dataType === "String") {
        hierarchyNextItem = nextItem.rename;
      }
      if (nextItem.dataType === "Date") {
        const queryItem = requiredArray.find((qItem) => {
          // console.log(qItem);

          if (qItem.dataType === "Date") {
            return nextItem.nanoId === qItem.nanoId;
          }
        });
        // hierarchy next item is present in the required array with same dateFormat
        if (queryItem) {
          if (
            `${nextItem.rename}${nextItem.dateFormat.value}` ===
            `${queryItem.rename}${queryItem.dateFormat.value}`
          ) {
            hierarchyNextItem = `${nextItem.rename}${nextItem.dateFormat.value}`;
          } else {
            hierarchyNextItem = null;
          }
        } else {
          // hierarchy next item is present in the required array with d/f dateFormat
          hierarchyNextItem = `${nextItem.rename}${nextItem.dateFormat.value}`;
        }
      }
      if (nextItem.dataType === "Number") {
        // console.log(element);
      }
    } else {
      hierarchyNextItem = null;
    }
  } else {
    hierarchyNextItem = null;
  }
  // console.log(hierarchyNextItem);

  return hierarchyNextItem;
}

const updateTableHeaderWithHirarchyKeys = ({
  destructuredHeader,
  rawRowKeys,
  rawGroupByKeys,
  isMeasureOnTop,
  headerHierarchyKeys,
  mappedHierarchy,
  vizType,
}) => {
  let transformedTableHeader = [];

  if (isMeasureOnTop) {
    // console.log(destructuredHeader);

    // console.log(mappedHierarchy);

    // console.log(headerHierarchyKeys);
    const transformedTableHeaderIndex0 = destructuredHeader[0].map(
      (element) => {
        // console.log(element);

        const rowMatchingKey = rawRowKeys.find((rItem) => {
          // console.log(rItem);
          return element.caption === rItem.responseKey;
        });
        // console.log(rowMatchingKey);

        if (rowMatchingKey) {
          const displayValue =
            rowMatchingKey.dataType === "Date"
              ? `${rowMatchingKey.dateUnit}(${rowMatchingKey.rename})`
              : element.caption;
          let tempraryItem = {
            ...element,
            hierarchyKey: rowMatchingKey.responseKey,
            nanoId: rowMatchingKey.nanoId,
            displayValue: displayValue || undefined,
          };
          // console.log(tempraryItem);

          const hierarchyNextItem = findHierarchyNextItem({
            mappedHierarchy,
            element: tempraryItem,
            isMeasureOnTop,
            requiredArray: rawRowKeys,
          });
          // console.log(hierarchyNextItem);
          if (hierarchyNextItem !== null) {
            if (headerHierarchyKeys.includes(hierarchyNextItem)) {
              return { ...tempraryItem, icon: "minus" };
            } else {
              return { ...tempraryItem, icon: "plus" };
            }
          } else {
            return {
              ...tempraryItem,
              hierarchyKey: null,
              icon: null,
            };
          }
        } else {
          // console.log(element.caption);
          return {
            ...element,
          };
        }
      }
    );
    transformedTableHeader.push(transformedTableHeaderIndex0);
    if (rawGroupByKeys.length) {
      // Start processing from `destructuredHeader.length - rawGroupByKeys.length`
      const startIndex = destructuredHeader.length - rawGroupByKeys.length;

      destructuredHeader.forEach((header, index) => {
        if (index >= startIndex) {
          const columnKey = rawGroupByKeys[index - startIndex]; // Align rawGroupByKeys with destructuredHeader
          // console.log(index, header);

          // console.log(index - startIndex);

          // console.log(columnKey);

          const transformedTableHeaderLength1 = header.map((element) => {
            // console.log(element);
            const displayValue = element.caption;
            let tempraryItem = {
              ...element,
              hierarchyKey: columnKey.responseKey,
              nanoId: columnKey.nanoId,
              displayValue: displayValue || undefined,
            };
            // console.log(tempraryItem);

            const hierarchyNextItem = findHierarchyNextItem({
              mappedHierarchy,
              element: tempraryItem,
              isMeasureOnTop,
              requiredArray: rawGroupByKeys,
            });
            // console.log(hierarchyNextItem);
            if (hierarchyNextItem !== null) {
              if (headerHierarchyKeys.includes(hierarchyNextItem)) {
                return { ...tempraryItem, icon: "minus" };
              } else {
                return { ...tempraryItem, icon: "plus" };
              }
            } else {
              return {
                ...tempraryItem,
                hierarchyKey: null,
                icon: null,
              };
            }
          });

          // Append the transformed header for this index
          transformedTableHeader.push(transformedTableHeaderLength1);
        } else {
          // console.log("Skipping index", destructuredHeader[index]);
        }
      });
    }
  } else {
    // destructuredHeader is divided into items this below logic works on the destructuredHeader[0] which contains the
    // rows items and distinct values of first item of column
    const transformedTableHeaderIndex0 = destructuredHeader[0].map(
      (element) => {
        // console.log(element);

        const rowMatchingKey = rawRowKeys.find((rItem) => {
          // console.log(rItem);
          if (rItem.dataType === "String" && element.dataType === "String") {
            return element.caption === rItem.rename;
          }
          if (rItem.dataType === "Date" && element.dataType === "Date") {
            return rItem.responseKey === element.caption;
          }
          if (rItem.dataType === "Number" && element.dataType === "Number") {
            // console.log(element);
            // console.log(rItem);
          }
        });
        // console.log(rowMatchingKey);

        if (rowMatchingKey) {
          const displayValue =
            rowMatchingKey.dataType === "Date"
              ? `${rowMatchingKey.dateUnit}(${rowMatchingKey.rename})`
              : element.caption;
          let tempraryItem = {
            ...element,
            hierarchyKey: rowMatchingKey.responseKey,
            nanoId: rowMatchingKey.nanoId,
            displayValue: displayValue || undefined,
          };
          // console.log(tempraryItem);

          const hierarchyNextItem = findHierarchyNextItem({
            mappedHierarchy,
            element: tempraryItem,
            isMeasureOnTop,
            requiredArray: rawRowKeys,
          });
          // console.log(hierarchyNextItem);
          if (hierarchyNextItem !== null) {
            if (headerHierarchyKeys.includes(hierarchyNextItem)) {
              return { ...tempraryItem, icon: "minus" };
            } else {
              return { ...tempraryItem, icon: "plus" };
            }
          } else {
            return {
              ...tempraryItem,
              hierarchyKey: null,
              icon: null,
            };
          }
        } else {
          // console.log(element);
          const columnKey = rawGroupByKeys[0];
          if (columnKey) {
            if (element.dataType !== "Number") {
              const displayValue = element.caption;
              let tempraryItem = {
                ...element,
                hierarchyKey: columnKey.responseKey,
                nanoId: columnKey.nanoId,
                displayValue: displayValue || undefined,
              };
              // console.log(tempraryItem);
              const hierarchyNextItem = findHierarchyNextItem({
                mappedHierarchy,
                element: tempraryItem,
                isMeasureOnTop,
                searchingFor: "column",
                requiredArray: rawGroupByKeys,
              });
              // console.log(hierarchyNextItem);
              if (hierarchyNextItem !== null) {
                if (headerHierarchyKeys.includes(hierarchyNextItem)) {
                  return { ...tempraryItem, icon: "minus" };
                } else {
                  return { ...tempraryItem, icon: "plus" };
                }
              } else {
                return { ...tempraryItem, icon: null };
              }
            } else {
              return {
                ...element,
                hierarchyKey: null,
                icon: null,
              };
            }
          } else {
            // console.log(element);
            return { ...element };
          }
        }
      }
    );
    transformedTableHeader.push(transformedTableHeaderIndex0);

    //
    if (rawGroupByKeys.length > 1) {
      for (let i = 1; i < destructuredHeader.length - 1; i++) {
        const columnKey = rawGroupByKeys[i];
        // console.log(`Processing index: ${i}, columnKey:`, columnKey);

        const transformedTableHeaderLength = destructuredHeader[i].map(
          (element) => {
            // console.log(element);
            const displayValue = element.caption;
            // console.log(displayValue);

            let temporaryItem = {
              ...element,
              hierarchyKey: columnKey.responseKey,
              nanoId: columnKey.nanoId,
              displayValue: displayValue || undefined,
            };
            // console.log(temporaryItem);

            const hierarchyNextItem = findHierarchyNextItem({
              mappedHierarchy,
              element: temporaryItem,
              isMeasureOnTop,
              requiredArray: rawGroupByKeys,
            });
            // console.log(hierarchyNextItem);

            if (columnKey.dataType !== "Number") {
              if (hierarchyNextItem !== null) {
                if (headerHierarchyKeys.includes(hierarchyNextItem)) {
                  return {
                    ...temporaryItem,
                    icon: "minus",
                  };
                } else {
                  return {
                    ...temporaryItem,
                    icon: "plus",
                  };
                }
              } else {
                return {
                  ...element,
                  icon: null,
                };
              }
            } else {
              return {
                ...element,
              };
            }
          }
        );

        // console.log(
        //   `Transformed for index ${i}:`,
        //   transformedTableHeaderLength
        // );

        // Push the processed data for the current index
        transformedTableHeader.push(transformedTableHeaderLength);
      }
    }

    const numberArrayOfDestructuredHeader =
      rawGroupByKeys.length
        ? destructuredHeader[rawGroupByKeys.length]
        : [];
    // console.log(numberArrayOfDestructuredHeader);

    numberArrayOfDestructuredHeader !== undefined &&
      numberArrayOfDestructuredHeader.length &&
      transformedTableHeader.push(numberArrayOfDestructuredHeader);
  }

  return transformedTableHeader;
};

export { updateTableHeaderWithHirarchyKeys };
